import * as mock from './mock';
import {
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  getCurrentUser as amplifyGetCurrentUser,
  fetchAuthSession as amplifyFetchAuthSession,
  signUp as amplifySignUp,
  confirmSignUp as amplifyConfirmSignUp,
  resendSignUpCode as amplifyResendSignUpCode,
  resetPassword as amplifyResetPassword,
  confirmResetPassword as amplifyConfirmResetPassword,
  autoSignIn as amplifyAutoSignIn,
} from '@aws-amplify/auth';

const isMock = process.env.REACT_APP_AUTH_MOCK === 'true';

export const signIn = isMock ? mock.signIn : amplifySignIn;
export const signOut = isMock ? mock.signOut : amplifySignOut;
export const getCurrentUser = isMock ? mock.getCurrentUser : amplifyGetCurrentUser;
export const fetchAuthSession = isMock ? mock.fetchAuthSession : amplifyFetchAuthSession;
export const signUp = isMock ? mock.signUp : amplifySignUp;
export const confirmSignUp = isMock ? mock.confirmSignUp : amplifyConfirmSignUp;
export const resendSignUpCode = isMock ? mock.resendSignUpCode : amplifyResendSignUpCode;
export const resetPassword = isMock ? mock.resetPassword : amplifyResetPassword;
export const confirmResetPassword = isMock ? mock.confirmResetPassword : amplifyConfirmResetPassword;
export const autoSignIn = isMock ? mock.autoSignIn : amplifyAutoSignIn;
